

import common from '@/tools/common'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
components: {
Grid,
GridItem,
GroupTitle,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem
},
data () {
return {
GridData: [


{text: '组合查询', link: '/HandBookStat', Querydata: ['WDDZ0003'], UserType: [common.UserType.Type1], icon: '组合查询.png'},


{text: '模拟计税', link: '/TaxCalculator', Querydata: ['WDDZ0006'], UserType: [common.UserType.Type1], icon: '模拟计税.png'},
{text: '更新日志', link: '/UpdateLog?type=0', Querydata: ['WDDZ0007'], UserType: [common.UserType.Type1], icon: '手册更新.png'},
{text: '更新日志', link: '/UpdateLog?type=1', Querydata: ['WDDZ0008'], UserType: [common.UserType.Type2], icon: '模拟计税.png'},
{text: '单位换算', link: '/UnitConvert', UserType: [common.UserType.Type3], icon: '计量单位.png'},


{text: '更新日志', link: '/UpdateLog?type=4', Querydata: ['WDDZ0009'], UserType: [common.UserType.Type3], icon: '手册更新.png'},


{text: '使用说明', link: '/PolicyDoc?type=4', UserType: [common.UserType.Type3], icon: '使用说明.png'}
]
}
}
}



// WEBPACK FOOTER //
// ./src/components/MyCustoms.vue